import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_DEVICES } from './url-constants';

type DeviceDevicesEndpointSpecification = ApiEndpointSpecification;
export const DeviceDevicesEndpointSpecification: DeviceDevicesEndpointSpecification = {
    url: DEVICE_DEVICES,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'DeviceDevicesRequestParams',
    requestBodySchemaName: 'DeviceDevicesRequestBody',
    okResponseSchemaName: 'DeviceDevicesOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 3,
};

export const invokeDeviceDevices = Helpers.makeApiRequestFn<
    Types.DeviceDevicesRequestParams,
    Types.DeviceDevicesRequestBody,
    Types.DeviceDevicesOkResponse
>(DeviceDevicesEndpointSpecification);
